export const admin = [
  { title: "Админ", type: "title" },
  {
    type: "list",
    title: "Пользователи",
    icon: "users-icon",
    links: [
      {
        type: "link",
        title: "Пользователи",
        icon: "circle-icon",
        name: "users",
      },
      {
        type: "link",
        title: "Группы",
        icon: "circle-icon",
        name: "groups",
      },
    ],
  }
];
